import "./SavingsSystemPoints.module.css";
import Header from "@/reusable_sections/Header";
import HeroSplit from "./sections/HeroSplit";
import HowItWorks from "./sections/HowItWorks";
import FaqContact from "./sections/FaqContact";
import Footer from "@/reusable_sections/Footer";
export default function SavingsSystemPointsPage() {
  return <div>
      <Header />
      <HeroSplit />
      <HowItWorks />
      <FaqContact />
      <Footer />
    </div>;
}